// removed by extract-text-webpack-plugin
module.exports = {"App":"CaptchaGenerator__App","app":"CaptchaGenerator__App","inner-style":"CaptchaGenerator__inner-style","innerStyle":"CaptchaGenerator__inner-style","rc-anchor-alert":"CaptchaGenerator__rc-anchor-alert","rcAnchorAlert":"CaptchaGenerator__rc-anchor-alert"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/CaptchaGenerator/CaptchaGenerator.css
// module id = 1113
// module chunks = 8